import * as Styled from './MHighlightNumeric.styles';
import { AAccentLine, AAccentLineAlignment, AAccentLineSize } from '../../atoms/AAccentLine/index';
import { ADigit, ADigitSize } from '../../atoms/ADigit/index';
import { ABody, ABodySize } from '../../atoms/ABody/index';
import { MButton } from '../MButton/index';
import { MHighlightNumericProps, MHighlightNumericAlignment } from './MHighlightNumeric.types';

const COMPONENT_NAME = 'm-web-ui-kit-MHighlightNumeric';
const TEST_ID = 'web-ui-kit-MHighlightNumeric';

export function MHighlightNumeric({
  alignment = MHighlightNumericAlignment.Centered,
  showCTA = true,
  aAccentLine = {
    size: AAccentLineSize.OnePx,
    alignment: AAccentLineAlignment.Centered,
  },
  aDigit,
  aBody,
  mButton,
  hasAccentLine = false,
}: MHighlightNumericProps) {
  return (
    <Styled.Wrapper data-component-name={COMPONENT_NAME} data-testid={TEST_ID} alignment={alignment}>
      {hasAccentLine && (
        <AAccentLine
          {...aAccentLine}
          alignment={
            alignment === MHighlightNumericAlignment.Left ? AAccentLineAlignment.Left : AAccentLineAlignment.Centered
          }
        />
      )}
      <ADigit {...aDigit} size={ADigitSize.Large} />
      {aBody?.bodyText && <ABody {...aBody} size={ABodySize.S} />}
      {showCTA && mButton?.buttonText && <MButton {...mButton} />}
    </Styled.Wrapper>
  );
}

export { MHighlightNumericAlignment };
export type { MHighlightNumericProps };
